import React from 'react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="flex justify-between items-center h-16" data-id="element-78">
          <div className="flex items-center gap-2" data-id="element-79">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-80">
              <div className="w-4 h-4 bg-white rounded-sm rotate-45" data-id="element-81" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-82">
              TokenGates.sh
            </span>
          </div>
          <nav className="hidden md:flex items-center gap-8" data-id="element-83">
            <a href="#how-it-works" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-84">
              How It Works
            </a>
            <a href="#features" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-85">
              Features
            </a>
            <a href="#pricing" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-86">
              Pricing
            </a>
            <a href="#faq" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-87">
              FAQ
            </a>
          </nav>
          <div className="flex items-center gap-4" data-id="element-88">
            <button className="text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-89">
              Log in
            </button>
            <a href="https://us.posthog.com/external_surveys/019da0fa-860d-0000-f825-d448b1152f42" target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors" data-id="element-90">
              Start Free
            </a>
          </div>
        </div>
      </div>
    </header>;
}